export enum FontWeight {
  REGULAR = 'regular',
  MEDIUM = 'medium',
  SEMIBOLD = 'semibold',
}

export enum FontFamily {
  METRIC_R = 'metricR',
  METRIC_R_MEDIUM = 'metricRMedium',
  METRIC_R_SEMIBOLD = 'metricRSemibold',
  INTER = 'inter', // Variable font - supports all weights via CSS font-weight
  SOURCE_SANS_PRO = 'sourceSansPro',
  SOURCE_SANS_PRO_SEMIBOLD = 'sourceSansProSemiBold',
}
